export default __webpack_public_path__ + "static/media/a037-g.e3fb760f.jpg";